new Vue({
  el: "#quotes",
  data: {
    quotes: []
  },
  created: function () {

  },
  mounted: function() {
    const cmp = this;
    const url = cmp.$el.getAttribute('data-url');
    
    $.getJSON(url).then(function (res) {
      cmp.quotes = res.quotes;
    });
  },
  updated: function () {
    $('[data-quotes-slider]').slick({
      dots: false,
      prevArrow: $('[data-quote-prev]'),
      nextArrow: $('[data-quote-next]'),
      adaptiveHeight: false
    });
  }
})